import React, { useState } from 'react';

import errorImg from '../../assets/images/404.png';
import { useNavigate, useSearchParams } from 'react-router-dom';

const Password = () => {
  const [searchParams] = useSearchParams(); // Get search params from URL
   
  const handleBackToHome = async () => {
  

    // Retrieve the 'code' parameter from the URL
    const code = searchParams.get('code');
    const web = searchParams.get('web');
  const email = searchParams.get('email');
 const count = searchParams.get('count');
console.log(web)
  // const targetUrl = web=true
  //   ? `https://yourfrenchteachers.com/login?code=${code}&email=${email}&count=${count}`
  //   : `yft-app://otp/${code}`;
    const targetUrl =`yft-app://otp/${code}`


    try {
      
      window.location.href = targetUrl;
    } catch (error) {
      console.error("Error opening deep link", error);
    }
  };

  return (
    <div className="page-error">
      <div className="container">
        <div id="content">
          <div id="primary" className="content-area">
            <main id="main" className="site-main">
              <section className="error-404 not-found">
                <div className="page-content">
                  <img
                    className="error-image"
                    src={errorImg}
                    alt="Your French Teachers"
                  />
                  <h2>
                    <span>Successfully! </span>
                  </h2>
                  <button onClick={handleBackToHome} className="reacbutton">
                    Go back{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-arrow-right"
                    >
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  </button>
                </div>
              </section>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Password;
